<template>
    <div id="hero" class="d-flex pt-5 flex-wrap align-items-center justify-content-center">
        <div class="container-fluid">
          <div class="row  hero-content" >
            <div class="col-12 hero-text">
              <div class="container">
                <div class="row justify-content-center mb-3">
                    <div class="">
                        <h2 class="header-text">
                        <span>A thought leadership</span> <br>
                        <span>platform for change</span>
                        </h2>
                        <p class="sub-text">Scholarship, Policy, Inovation and Practitioner Networks</p>
                        <p><a class="btn btn-outline-light py-2 px-3 m-2" style="font-weight:bold" href="#signUp">Learn More</a></p>
                    </div>
                </div>
                <div class="row justify-content-center hero-logo">
                  <div class="col-4 col-lg-2 col-md-3">
                      <img class="img-fluid" src="../assets/images/african_union.png" alt="">
                  </div>
                  <div class="col-4 col-lg-2 col-md-3">
                      <img class="img-fluid" src="../assets/images/afrochampions.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>
<style scoped>
@media screen and (max-width: 567px) {
    h2{
        font-size: 2.1em !important;
    }
    .img{
      height: 50px;
    }
}
</style>